import { http } from "@/configurations/axios";

/**
 * Service responsável por toda a comunicação com a integração Sicoob.
 *
 * IMPORTANTE: nenhuma chamada é feita diretamente para a API do Sicoob.
 * Todas as requisições passam pelo backend Laravel, que é o único
 * responsável por usar o certificado digital e as credenciais.
 */

// ------- Conta bancária / configuração Sicoob -------

export const getStatusSicoob = (contaBancariaId) =>
  http.get(`/financeiro/contas-bancarias/${contaBancariaId}/sicoob/status`);

export const testarConexaoSicoob = (contaBancariaId) =>
  http.post(
    `/financeiro/contas-bancarias/${contaBancariaId}/sicoob/testar-conexao`
  );

// ------- Geração de cobranças -------

export const gerarBoletoSicoob = (contaReceberId, payload) =>
  http.post(
    `/financeiro/contas-receber/${contaReceberId}/sicoob/boleto`,
    payload
  );

export const gerarPixSicoob = (contaReceberId, payload) =>
  http.post(`/financeiro/contas-receber/${contaReceberId}/sicoob/pix`, payload);

export const gerarBoletoHibridoSicoob = (contaReceberId, payload) =>
  http.post(
    `/financeiro/contas-receber/${contaReceberId}/sicoob/boleto-hibrido`,
    payload
  );

// ------- Consulta de cobranças -------

export const listarCobrancasContaReceber = (contaReceberId) =>
  http.get(`/financeiro/contas-receber/${contaReceberId}/cobrancas`);

export const atualizarStatusCobranca = (cobrancaId) =>
  http.post(
    `/financeiro/cobrancas-bancarias/${cobrancaId}/atualizar-status`
  );

// ------- Helpers de status de cobrança -------

export const STATUS_COBRANCA = {
  pendente: { label: "Pendente", variant: "warning" },
  registrada: { label: "Registrada", variant: "info" },
  aguardando_pagamento: { label: "Aguardando pagamento", variant: "info" },
  paga: { label: "Paga", variant: "success" },
  liquidada: { label: "Liquidada", variant: "success" },
  cancelada: { label: "Cancelada", variant: "secondary" },
  erro: { label: "Erro", variant: "danger" },
};

export const getStatusCobrancaLabel = (status) =>
  STATUS_COBRANCA[status]?.label || status || "—";

export const getStatusCobrancaVariant = (status) =>
  STATUS_COBRANCA[status]?.variant || "secondary";

const TIPO_COBRANCA = {
  boleto: "Boleto",
  pix: "Pix",
  "boleto-hibrido": "Boleto híbrido",
  boleto_hibrido: "Boleto híbrido",
  hibrido: "Boleto híbrido",
};

export const getTipoCobrancaLabel = (tipo) =>
  TIPO_COBRANCA[tipo] || tipo || "—";

export default {
  getStatusSicoob,
  testarConexaoSicoob,
  gerarBoletoSicoob,
  gerarPixSicoob,
  gerarBoletoHibridoSicoob,
  listarCobrancasContaReceber,
  atualizarStatusCobranca,
  getStatusCobrancaLabel,
  getStatusCobrancaVariant,
  getTipoCobrancaLabel,
  STATUS_COBRANCA,
};
